"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expandedRowsTypes = exports.expandedRowsArrowPositions = exports.enumOrderBy = void 0;
var enumOrderBy = {
  ASC: 'asc',
  DESC: 'desc'
};
exports.enumOrderBy = enumOrderBy;
var expandedRowsArrowPositions = {
  LEFT: 'left',
  RIGHT: 'right'
};
exports.expandedRowsArrowPositions = expandedRowsArrowPositions;
var expandedRowsTypes = {
  SINGLE: 'single',
  MULTIPLE: 'multiple'
};
exports.expandedRowsTypes = expandedRowsTypes;
//# sourceMappingURL=constants.js.map